// import React, { Fragment } from "react";
// const scriptContent = `
//   (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
//   n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
//   ineum('reportingUrl', 'https://eum-blue-saas.instana.io');
//   ineum('key', 'D48vCpBPS867P4in4QfFBw');
//   ineum('trackSessions');
//   ineum('meta', 'platform', 'redesign');
// `;

// const InstanaTracking = () => (
//   <Fragment>
//     <script dangerouslySetInnerHTML={{ __html: scriptContent }} />
//     <script
//       defer
//       crossOrigin="anonymous"
//       src="https://eum.instana.io/1.7.3/eum.min.js"
//       integrity="sha384-pYPTSdvwsCsJubrLEHxrtlG8F/RCwPOMs1zjJA+IcMNFy3sbID3uZoYSXtxS+frI"
//     />
//   </Fragment>
// );
// export default InstanaTracking;

"use client";

import Script from "next/script";

const InstanaTracking = () => (
  <>
    <link
      rel="preload"
      href="https://eum.instana.io/1.7.3/eum.min.js"
      as="script"
      crossOrigin="anonymous"
      integrity="sha384-pYPTSdvwsCsJubrLEHxrtlG8F/RCwPOMs1zjJA+IcMNFy3sbID3uZoYSXtxS+frI"
    />
    <Script
      id="instana-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
          n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
          ineum('reportingUrl', 'https://eum-blue-saas.instana.io');
          ineum('key', 'D48vCpBPS867P4in4QfFBw');
          ineum('trackSessions');
          ineum('meta', 'platform', 'redesign');
        `,
      }}
    />
    <Script
      id="instana-script"
      strategy="afterInteractive"
      src="https://eum.instana.io/1.7.3/eum.min.js"
      crossOrigin="anonymous"
      integrity="sha384-pYPTSdvwsCsJubrLEHxrtlG8F/RCwPOMs1zjJA+IcMNFy3sbID3uZoYSXtxS+frI"
    />
  </>
);

export default InstanaTracking;
